/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
/**
 * 
 * @export
 * @interface LoginResultDto
 */
export interface LoginResultDto {
    /**
     * 
     * @type {string}
     * @memberof LoginResultDto
     */
    targetUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof LoginResultDto
     */
    readonly success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof LoginResultDto
     */
    $type?: LoginResultDtoTypeEnum;
}


/**
 * @export
 */
export const LoginResultDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedAuthorizationAccountDtoLoginResultDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.Authorization.Account.Dto.LoginResultDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type LoginResultDtoTypeEnum = typeof LoginResultDtoTypeEnum[keyof typeof LoginResultDtoTypeEnum];


/**
 * Check if a given object implements the LoginResultDto interface.
 */
export function instanceOfLoginResultDto(value?: unknown): value is LoginResultDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(LoginResultDtoTypeEnum)[0];
}

export function LoginResultDtoFromJSON(json: any): LoginResultDto {
    return LoginResultDtoFromJSONTyped(json, false);
}

export function LoginResultDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LoginResultDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'targetUrl': !exists(json, 'targetUrl') ? undefined : json['targetUrl'],
        'success': !exists(json, 'success') ? undefined : json['success'],
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function LoginResultDtoToJSON(value?: LoginResultDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'targetUrl': value.targetUrl,
        '$type': value.$type,
    });
}

